/**
 * AUGA Reviews Carousel — aplica layout horizontal a la sección Revie
 * cuando los selectores CSS no coinciden con la estructura de la app.
 */
(function () {
  if (!/template-product/.test(document.body.className || '')) {
    return;
  }

  function applyCarousel() {
    const revieSection = document.querySelector('[class*="revie"], [id*="revie"]');
    if (!revieSection) return;

    if (revieSection.querySelector('.auga-reviews-carousel')) return; // Ya aplicado

    // Buscar el contenedor directo de las cards (padre común de 2+ cards)
    const cards = revieSection.querySelectorAll('[class*="review-card"], [class*="review-item"], [class*="revie-card"], [class*="card"][class*="revie"]');
    if (cards.length >= 2) {
      const parent = cards[0].parentElement;
      if (parent && parent.closest('[class*="revie"]')) {
        parent.classList.add('auga-reviews-carousel');
        return;
      }
    }

    // Fallback: div con display grid o que contenga varias cards
    const gridDiv = revieSection.querySelector('div[style*="grid"], [class*="reviews-list"], [class*="review-list"], [class*="grid"]');
    if (gridDiv) {
      gridDiv.classList.add('auga-reviews-carousel');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCarousel);
  } else {
    applyCarousel();
  }

  // Las apps pueden cargar contenido de forma asíncrona
  const observer = new MutationObserver(() => {
    if (!document.querySelector('[class*="revie"] .auga-reviews-carousel')) {
      applyCarousel();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 5000);
})();
